import { Breadcrumbs, Link, Typography, IconButton, Box, Popover } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PageHeader(props) {
  const params = useParams();
  const { id, title, pageConfig, logo } = props;
  const [tooltipAnchor, setTooltipAnchor] = useState(null);
  const pageInfo = pageConfig?.[id];

  let paths = window.location.pathname.split('/').filter((path) => path !== '');
  paths = paths.slice(0, Object.keys(params).length ? -Object.keys(params).length : paths.length);

  if (props.subPageId) {
    paths.push(props.subPageId);
  }

  const isTooltipOpen = Boolean(tooltipAnchor);

  return (
    <React.Fragment>
      {logo ? (
        <img src={logo} />
      ) : (
        <Box display="flex" flexDirection="row" alignItems="center" justifyItems="center">
          <Typography id={`${id}__text_title`} component="h2">
            {title}
          </Typography>
          {pageInfo?.tooltip && (
            <IconButton
              onClick={(e) => setTooltipAnchor(e.currentTarget)}
              aria-label={`Open ${pageInfo?.tooltipTitle || title} information`}
              id={`${id}__button_info`}
            >
              <FontAwesomeIcon icon={faCircleInfo} />
            </IconButton>
          )}
        </Box>
      )}

      <Breadcrumbs className="myOdu__breadcrumbs" id={`${id}__breadCrumbs`} aria-label="breadcrumb">
        <Link href="/" id={`${id}__link_dashboard`}>
          Dashboard
        </Link>
        {paths.map((path, index, array) => {
          const pageDetails = pageConfig[path];
          if (!pageDetails) {
            return null;
          }
          if (index === array.length - 1) {
            return (
              <Typography key={index} id={`${id}__text_${pageDetails.id}`}>
                {pageDetails.title}
              </Typography>
            );
          }

          return (
            <Link key={index} href={`/${pageDetails.url}`} id={`${id}__link_${pageDetails.id}`}>
              {pageDetails.title}
            </Link>
          );
        })}
      </Breadcrumbs>

      {pageInfo?.tooltip && (
        <Popover
          id={`${id}__popover_info`}
          open={isTooltipOpen}
          anchorEl={tooltipAnchor}
          onClose={() => setTooltipAnchor(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          PaperProps={{ sx: { width: 'min(52rem, calc(100vw - 2rem))', p: 2 } }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Box display="flex" alignItems="center" gap={1}>
              <FontAwesomeIcon icon={faCircleInfo} />
              <Typography component="h3" variant="h5">
                {pageInfo?.tooltipTitle || title}
              </Typography>
            </Box>
            <IconButton
              onClick={() => setTooltipAnchor(null)}
              aria-label="Close information tooltip"
              id={`${id}__button_closeInfo`}
            >
              <FontAwesomeIcon icon={faXmark} />
            </IconButton>
          </Box>
          <Box id={`${id}__popover_content`}>{pageInfo.tooltip}</Box>
        </Popover>
      )}
    </React.Fragment>
  );
}
